export default __webpack_public_path__ + "static/media/individualki.96215a21.pdf";